import { translate } from "../../../common/providers";

const translateEnum = (type, value) => translate(`consistency-check.enum.${type}.${value}`.replaceAll("_", "-"));
export const translateEnumRowType = (value) => translateEnum("row-type", value?.toLowerCase());
export const translateEnumStatus = (value) => translateEnum("status", value?.toLowerCase());
